module.exports = __webpack_public_path__ + "img/blockedcash.223f6647.svg";